import React from "react";
import { connect } from "react-redux";

class IsAuthenticated extends React.Component {
  render() {
    const { isAuthenticated, itIs, isNot } = this.props
    return (
      <div>
        {isAuthenticated ? itIs : isNot}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  isAuthenticated: state.auth ? true : false
});

export default connect(mapStateToProps, undefined)(IsAuthenticated);
